import React from "react";
import {NavLink} from "react-router-dom";
import pageList from './pageList';
import Request, {CODES} from '../../utils/Request';
import {Duplicate} from '../../utils/svgs';

import UserContext from '../../utils/UserContext';
import {PERMISSIONS} from '../../utils/Request';


class pageListProducts extends pageList {
	
	constructor(props){
		super(props)
		this.apiName = 'products';
		this.listSlug = 'productos';
		this.singleItem = 'producto'; //Name of a single list item
		this.listTitle = 'Productos';

		// this.hasRowOptions = false;

		this.synchronize = this.synchronize.bind(this);
	}
	
	componentDidMount(){
		this.requestPages();
	}

	getTable(pages){
		let table = {};
		table.headers = [
			{
				slug: 'brand',
				name: 'Brand',
				class: 'item-medium',
				canSearch: true,
			},
			{
				slug: 'name',
				name: 'Nombre',
				class: 'item-big',
				canSearch: true,
			},
			{
				slug: 'sku',
				name: 'SKU',
				class: 'item-big',
				canSearch: true,
			},
			{
				slug: 'sku_soultek',
				name: 'SKU Soultek',
				class: 'item-big',
				canSearch: true,
				canSort: true,
				sortType: 'string',
			},
			{
				slug: 'sku_stk',
				name: 'SKU STK',
				class: 'item-big',
				canSearch: true,
				canSort: true,
				sortType: 'string',
			},
			{
				slug: 'provider',
				name: 'Proveedor',
				class: 'item-medium',
				canSearch: true,
			},
			{
				slug: 'location_store',
				name: 'Almacen',
				class: 'item-medium',
			},
			{
				slug: 'bar_code',
				name: 'Código Barras',
				class: 'item-medium',
				canSearch: true,
			},
		];
		table.rows = [];
		for(let i = 0; i < pages.length; i++){
			table.rows.push(this.createRow(pages[i]));
		}
		return table;
	}

	createRow(page){
		return {
			item : page,
			brand : page.brand,
			sku : page.sku,
			name : page.name,
			sku_soultek : page.sku_soultek,
			sku_stk : page.sku_stk,
			provider : page.provider,
			location_store: page.location_store,
			bar_code: page.bar_code,
		};
	}

	synchronize(){
		if(!this.synchronizing){
			this.synchronizing = true;
			alert("Se está sincronizando los productos")
			Request.postAuth('/api/products/price-cost')
				.then(json => {
					this.synchronizing = false;
					if( json.code === CODES.success ){
						alert(json.message);
					}else{
						alert(json.message);
					}
			});
		}
	}

	renderBeforeAddNew(){
		return <React.Fragment>
			<UserContext.Consumer>
				{user => {
					if(PERMISSIONS.canAdministrator(user)){
						return (
							<button className="button button-default font-p font-white font-center" onClick={this.synchronize}>Sincronizar</button>
						)
					}
				}}
			</UserContext.Consumer>
		</React.Fragment>
	}
	
}





export default pageListProducts;




